import {createReducer} from '@reduxjs/toolkit'
import {deleteRsvp, getMemberRsvp, sendRsvp, sendRsvpOld, updateRsvpStatus} from '../actions/rsvp'
import {MemberRsvp} from '../types/state'

const getDefaultState = (): MemberRsvp => ({
  rsvp: null,
  loaded: false,
})

export const memberRsvp = createReducer(getDefaultState(), builder => {
  builder
    .addCase(getMemberRsvp.fulfilled, (state, action) => {
      if (action.payload) {
        state.rsvp = action.payload
      }
      state.loaded = true
    })
    .addCase(sendRsvp.fulfilled, (state, action) => {
      state.rsvp = action.payload.rsvp
      state.loaded = true
    })
    .addCase(sendRsvpOld.fulfilled, (state, action) => {
      state.rsvp = action.payload.rsvp
      state.loaded = true
    })
    .addCase(deleteRsvp.pending, state => {
      state.rsvp = null
      state.loaded = true
    })
    .addCase(updateRsvpStatus.fulfilled, (state, action) => {
      const {status} = action.meta.arg
      state.rsvp = {...state.rsvp, status}
    })
    .addCase(getMemberRsvp.pending, state => {
      state.rsvp = null
      state.loaded = false
    })
    .addCase(getMemberRsvp.rejected, state => {
      state.loaded = true
    })
})
